import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { FieldValues } from "react-hook-form";
import { Controller } from "react-hook-form";
import type { FormComponentProps } from "./FormComponentProps";

interface FormTimePickerProps<TFieldValues extends FieldValues = FieldValues> extends FormComponentProps<TFieldValues> {
  readonly fullWidth?: boolean;
}

function FormTimePicker<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  fullWidth,
}: FormTimePickerProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl">
          <TimePicker
            views={["hours", "minutes"]}
            onChange={onChange}
            value={value}
            label={label}
            slotProps={{ textField: { fullWidth } }}
          />
        </LocalizationProvider>
      )}
    />
  );
}

export default FormTimePicker;
